
import { EntityConfig } from './types';

export const PROJECT_CONFIG: EntityConfig = {
  entityType: 'project',
  tableName: 'project_research_attachments',
  entityIdColumn: 'project_id',
  researchLimit: 5,
  queryKey: ['project-attached-research'],
  displayName: 'Project Research'
};
